// src/store/slices/organizationSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

const initialState = {
  organizations: [],
  currentOrganization: null,
  currentSubscription: null,
  dashboardStats: {
    recentProblems: [],
    recentSolutions: [],
    tagsCount: 0,
    bidsCount: 0,
    problemsTaggedCount: 0
  },
  loading: false,
  error: null,
};

export const fetchCurrentSubscription = createAsyncThunk(
  'organizations/fetchSubscription',
  async (_, { rejectWithValue }) => {
    try {
      const data = await api.get('/subscriptions/current/');
      return data;
    } catch (error) {
      return rejectWithValue(error.data?.message || 'Failed to fetch subscription');
    }
  }
);

export const fetchDashboardStats = createAsyncThunk(
  'organizations/fetchDashboardStats',
  async (_, { rejectWithValue }) => {
    try {
      // This assumes you have a backend endpoint that aggregates these stats
      const data = await api.get('/accounts/dashboard-stats/');
      return data;
    } catch (error) {
      return rejectWithValue(error.data?.message || 'Failed to fetch stats');
    }
  }
);

const organizationSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentSubscription.pending, (state) => { state.loading = true; })
      .addCase(fetchCurrentSubscription.fulfilled, (state, action) => {
        state.loading = false;
        state.currentSubscription = action.payload;
      })
      .addCase(fetchCurrentSubscription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.dashboardStats = action.payload;
      });
  },
});

export const { clearError } = organizationSlice.actions;
export default organizationSlice.reducer;